module.exports = __webpack_public_path__ + "fonts/d12e4e15d6e01ff7ceceea6f00e32159.svg";